import React                                            from 'react';
import './style.scss'

export const ButtonTransparent = (props) => {
  return <button {...props} className={'button-transparent ' + props.className}>
    {props.children}
  </button>
}